import * as React from "react";

import { Root } from "./CrossfitTableCaptionHeader.styles";

interface CaptionHeaderProps {
    children: JSX.Element;
    align?: "right";
}

export function CrossfitTableCaptionHeader(props: CaptionHeaderProps): JSX.Element {
    return <Root alignRight={props.align === "right"}>{props.children}</Root>;
}
